import { useCallback, useEffect, useState } from "react";

const TICK_MS = 250;

/** Seconds left of a `seconds` cooldown started on mount; `restart()` begins it again. */
export function useCountdown(seconds: number): { remaining: number; restart: () => void } {
  const [startedAt, setStartedAt] = useState(() => Date.now());
  const [now, setNow] = useState(() => Date.now());
  const remaining = Math.max(0, seconds - Math.floor((now - startedAt) / 1000));
  useEffect(() => {
    if (remaining === 0) return undefined;
    const timer = setInterval(() => {
      setNow(Date.now());
    }, TICK_MS);
    return () => {
      clearInterval(timer);
    };
  }, [remaining]);
  const restart = useCallback(() => {
    const at = Date.now();
    setStartedAt(at);
    setNow(at);
  }, []);
  return { remaining, restart };
}
